import { makeStyles } from "@material-ui/core/styles";

const styles = makeStyles(theme => ({
  mainContainer: {
    marginTop: "93px"

    // width: "100%"
  },
  sectionContainer: { display: "flex", justifyContent: "center" },
  sectionText: {
    width: "633px",
    margin: "49px 13px 64px 11px",
    fontFamily: "Trebuchet",
    fontSize: "38px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "-0.59px",
    textAlign: "center",
    color: "rgba(0, 0, 0, 0.87)"
  },
  error404Section: {
    backgroundImage:
      "linear-gradient(\n180deg\n,rgba(44,161,255,0.53) 0%,rgba(255,255,255,0) 70%)"
  }
}));

export default styles;
